import { InputText } from '@innovyze/stylovyze';
import { InputAdornment } from '@mui/material';
import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations';
import { useFormikContext } from 'formik';
import React, { ChangeEvent } from 'react';
import { useSelector } from 'react-redux';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { CustomInfoCard } from './GeneralSettingsFields.styles';

export default function DefaultServiceLevels() {
	const { t } = useGlobalization();
	const { values } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();
	const companySettingsErrors =
		useSelector(getValue).companySettings.companySettingsErrors || {};

	const setUpdateCurrentCompanySettingsNumberField = (
		e: ChangeEvent<HTMLInputElement>,
	) => {
		setGeneralSettingsFields({ [e.target.name]: +e.target.value });
	};

	return (
		<CustomInfoCard fullHeight title={t('Default Service Levels')}>
			<InputText
				fieldAttrs={{
					name: 'simulationServiceLevelDefaultPressureHeadAmount',
				}}
				textField={{
					label: t('Service Level Minimum Pressure'),
					type: 'number',
					fullWidth: true,
					value: parseInt(
						`${values.simulationServiceLevelDefaultPressureHeadAmount}`,
					),
					InputProps: {
						inputProps: {
							dataCy: 'servicePressure',
							min: 0,
							pattern: /[0-9]/,
						},
						endAdornment: (
							<InputAdornment position="end">
								{values.UOM === 'Metric' ? t('mH2O') : t('PSI')}
							</InputAdornment>
						),
					},
				}}
				onDebounceChange={setUpdateCurrentCompanySettingsNumberField}
				networkError={
					companySettingsErrors.simulationServiceLevelDefaultPressureHeadAmount
				}
			/>
			<InputText
				fieldAttrs={{
					name: 'simulationServiceLevelDefaultTimeInMinutes',
				}}
				textField={{
					fullWidth: true,
					label: t('Service Level Minimum Duration'),
					type: 'number',
					value: parseInt(
						`${values.simulationServiceLevelDefaultTimeInMinutes}`,
					),
					InputProps: {
						inputProps: {
							dataCy: 'serviceDuration',
							min: 0,
							pattern: /[0-9]/,
						},
						endAdornment: (
							<InputAdornment position="end">
								{t('min')}
							</InputAdornment>
						),
					},
				}}
				onDebounceChange={setUpdateCurrentCompanySettingsNumberField}
				networkError={
					companySettingsErrors.simulationServiceLevelDefaultTimeInMinutes
				}
			/>
		</CustomInfoCard>
	);
}
